import type { BiomassDataRow } from '../../utils/productionUnitTable'
import { findAvailableLotMatch } from '../../utils/lotIdentity'

export type AvailableLot = {
  id: string
  lotKey?: string | null
}

export const resolveBiomassDraftLot = (
  lotId: string,
  availableLots: AvailableLot[]
): AvailableLot | null => {
  const explicitLotId = typeof lotId === 'string' ? lotId.trim() : ''
  if (!explicitLotId) return null

  const exactLot = availableLots.find((lot) => String(lot.id ?? '').trim() === explicitLotId)
  if (exactLot) return exactLot

  const resolvedLotId = findAvailableLotMatch(explicitLotId, availableLots)
  if (resolvedLotId.status !== 'matched') return null

  return resolvedLotId.match
}

export const resolveBiomassDraftLotId = (
  row: Pick<BiomassDataRow, 'lotId' | 'lot'>,
  availableLots: AvailableLot[]
): string => {
  const explicitLotId = typeof row.lotId === 'string' ? row.lotId.trim() : ''
  if (explicitLotId) {
    const resolvedLot = resolveBiomassDraftLot(explicitLotId, availableLots)
    if (resolvedLot) return resolvedLot.id

    return explicitLotId
  }

  const resolvedLot = findAvailableLotMatch(row.lot, availableLots)
  if (resolvedLot.status !== 'matched') return ''

  return resolvedLot.match.id
}